import * as React from 'react';
import { ToastOptions, toast } from 'react-toastify';
import { MdClose } from 'react-icons/md';
import { IconBaseProps } from 'react-icons';
import { ToastOptionsMessage, ToastPosition, ToastType } from 'ui/constants';
import styles from './toast-factory.scss';

const CustomCloseButton = (toastProps: IconBaseProps) => {
  const { ...validProps } = toastProps;
  return <MdClose {...validProps} />;
};

export enum AutoCloseDuration {
  Default = 5000,
  Longer = 10000
}

const defaultConfiguration = {
  position: ToastPosition.TOP_LEFT,
  autoClose: 5000,
  closeButton: <CustomCloseButton size={22} />,
  zIndex: '2001'
};

export const toastFactory = (configuration?: ToastOptions) => {
  let toastId = null;

  const config: ToastOptions = { ...defaultConfiguration, ...configuration };

  return {

    dispatchInfo: (message: string) => toastId = toast(message || '', {
      ...config,
      type: ToastType.INFO,
      className: `${styles.toastContainer} ${styles.infoToast}`,
      bodyClassName: styles.toastBody,
      progressClassName: styles.infoToastProgress
    }),

    dispatchSuccess: (message: string) => toastId = toast(message || '', {
      ...config,
      type: ToastType.SUCCESS,
      className: `${styles.toastContainer} ${styles.successToast}`,
      bodyClassName: styles.toastBody,
      progressClassName: styles.successToastProgress
    }),

    dispatchError: (message: string) => toastId = toast(message || '', {
      ...config,
      type: ToastType.ERROR,
      className: `${styles.toastContainer} ${styles.errorToast}`,
      bodyClassName: styles.toastBody,
      progressClassName: styles.errorToastProgress
    }),

    updateSuccess: (message: ToastOptionsMessage) => {
      return toastId && toast.update(toastId, {
        ...config,
        type: ToastType.SUCCESS,
        className: `${styles.toastContainer} ${styles.successUpdateToast}`,
        bodyClassName: styles.toastBody,
        hideProgressBar: true,
        render: message
      });
    },

    updateError: (message: ToastOptionsMessage) => {
      return toastId && toast.update(toastId, {
        ...config,
        type: ToastType.ERROR,
        className: `${styles.toastContainer} ${styles.errorToast}`,
        bodyClassName: styles.toastBody,
        progressClassName: styles.errorToastProgress,
        render: message
      });
    },

    close: () => {
      return toastId && toast.dismiss(toastId);
    }
  };
};
